module.exports = __webpack_public_path__ + "static/media/interactive2.e36d870d.svg";